export default __webpack_public_path__ + "static/media/ktmwcares.40b280c4.png";